export class TypedError extends Error {
  public type: string = ""

  constructor(message: string, type: string){
    super(message)
    this.type = type
  }
}

export class TypedErrorField extends Error {
  public type: string = ""
  public field: string = ""
  public legacyMessage: string = ""

  constructor(message: string = "", type: string ="", field: string ="", legacyMessage: string = ""){
    super(message)
    this.type = type
    this.field = field
    this.legacyMessage = legacyMessage
  }
}


export default (message: string, type: string) => {
  const error = new TypedError(message, type);
  throw error;
};
